export const enviroment = {
  name: 'staging',
  production: false,
  api: 'https://654542c15a0b4b04436de1c8.mockapi.io/api/v1/',
  url: 'https://t7225r2xgb.execute-api.us-west-2.amazonaws.com/',
  url_cdn: 'https://d39wx839mc90rh.cloudfront.net/',
  archivo_contrato_colectivo: 'https://dyjmg6csln2q7.cloudfront.net/documentos/Contrato_Colectivo_Copec.pdf',
  archivo_brochure_beneficios: 'https://dyjmg6csln2q7.cloudfront.net/documentos/BENEFICIOS-2026.pdf',
  template_reconocimiento_deuda: 'https://dyjmg6csln2q7.cloudfront.net/documentos/template_reconocimiento_de_deuda.pdf',
  template_reconocimiento_deuda_compania: 'https://dyjmg6csln2q7.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_bienestar: 'https://dyjmg6csln2q7.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_viajes: 'https://dyjmg6csln2q7.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_libre_disposicion: 'https://dyjmg6csln2q7.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_compra_vivienda: 'https://dyjmg6csln2q7.cloudfront.net/documentos/RECONOCIMIENTO_UF.pdf',
  template_reconocimiento_deuda_reparacion_vivienda: 'https://dyjmg6csln2q7.cloudfront.net/documentos/RECONOCIMIENTO_UF.pdf',
  formato_carga_participantes: 'https://dyjmg6csln2q7.cloudfront.net/documentos/Formato_Carga_de_Participantes.xlsx',
  template_reconocimiento_deuda_credito_medico:'https://d39wx839mc90rh.cloudfront.net/documentos/PRESTAMO_RECONOCIMIENTO_DEUDA_TR.pdf',

  // Caja navidad
  detalle_caja_2026: 'https://dyjmg6csln2q7.cloudfront.net/documentos/Detalle_cajas_2026.pdf',

  fusionAuthConfig: {
    timeoutFactor: 0.9,
    client_id: '02a01857-3c29-44a0-9f5c-465015c5dc10',
    issuer: 'https://copec-sa.fusionauth.io',
  },
};
